<template>
  <section>
    <v-row>
      <v-col cols="12" sm="4">
        <v-row no-gutters>
          <span class="caption">Monaie</span>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="0.05"
            :value="argent_5cent"
            :difference="getDifference('argent_5cent')"
            @input="e => updateProps('argent_5cent', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="0.10"
            :value="argent_10cent"
            :difference="getDifference('argent_10cent')"
            @input="e => updateProps('argent_10cent', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="0.25"
            :value="argent_25cent"
            :difference="getDifference('argent_25cent')"
            @input="e => updateProps('argent_25cent', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="1.00"
            :value="argent_1dollar"
            :difference="getDifference('argent_1dollar')"
            @input="e => updateProps('argent_1dollar', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="2.00"
            :value="argent_2dollar"
            :difference="getDifference('argent_2dollar')"
            @input="e => updateProps('argent_2dollar', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4">
        <v-row no-gutters>
          <span class="caption">Billet</span>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="5.00"
            :value="argent_5dollar"
            :difference="getDifference('argent_5dollar')"
            @input="e => updateProps('argent_5dollar', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="10.00"
            :value="argent_10dollar"
            :difference="getDifference('argent_10dollar')"
            @input="e => updateProps('argent_10dollar', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="20.00"
            :value="argent_20dollar"
            :difference="getDifference('argent_20dollar')"
            @input="e => updateProps('argent_20dollar', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="50.00"
            :value="argent_50dollar"
            :difference="getDifference('argent_50dollar')"
            @input="e => updateProps('argent_50dollar', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="100.00"
            :value="argent_100dollar"
            :difference="getDifference('argent_100dollar')"
            @input="e => updateProps('argent_100dollar', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4">
        <v-row no-gutters>
          <span class="caption">Rouleaux</span>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="0.05"
            :value="rouleaux_5cent"
            :difference="getDifference('rouleaux_5cent')"
            @input="e => updateProps('rouleaux_5cent', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="0.10"
            :value="rouleaux_10cent"
            :difference="getDifference('rouleaux_10cent')"
            @input="e => updateProps('rouleaux_10cent', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="0.25"
            :value="rouleaux_25cent"
            :difference="getDifference('rouleaux_25cent')"
            @input="e => updateProps('rouleaux_25cent', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="1.00"
            :value="rouleaux_1dollar"
            :difference="getDifference('rouleaux_1dollar')"
            @input="e => updateProps('rouleaux_1dollar', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
        <v-row no-gutters>
          <TillFondCaisseInput
            label="2.00"
            :value="rouleaux_2dollar"
            :difference="getDifference('rouleaux_2dollar')"
            @input="e => updateProps('rouleaux_2dollar', Number(e))"
          ></TillFondCaisseInput>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import round10 from "round10";
import TillFondCaisseInput from "./TillFondCaisseInput";
export default {
  name: "TillFondCaisse",
  components: {
    TillFondCaisseInput
  },
  props: {
    argent_5cent: {
      type: Number,
      required: true
    },
    argent_10cent: {
      type: Number,
      required: true
    },
    argent_25cent: {
      type: Number,
      required: true
    },
    argent_1dollar: {
      type: Number,
      required: true
    },
    argent_2dollar: {
      type: Number,
      required: true
    },
    argent_5dollar: {
      type: Number,
      required: true
    },
    argent_10dollar: {
      type: Number,
      required: true
    },
    argent_20dollar: {
      type: Number,
      required: true
    },
    argent_50dollar: {
      type: Number,
      required: true
    },
    argent_100dollar: {
      type: Number,
      required: true
    },
    rouleaux_5cent: {
      type: Number,
      required: true
    },
    rouleaux_10cent: {
      type: Number,
      required: true
    },
    rouleaux_25cent: {
      type: Number,
      required: true
    },
    rouleaux_1dollar: {
      type: Number,
      required: true
    },
    rouleaux_2dollar: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    current: {
      required: true
    },
    default: {
      required: true
    }
  },
  methods: {
    updateProps(type, value) {
      this.$emit(`update:${type}`, Math.floor(value));
      setTimeout(() => this.calculateTotal(), 100);
    },
    calculateTotal() {
      const total =
        this.argent_5cent * 0.05 +
        this.argent_10cent * 0.1 +
        this.argent_25cent * 0.25 +
        this.argent_1dollar * 1 +
        this.argent_2dollar * 2 +
        this.argent_5dollar * 5 +
        this.argent_10dollar * 10 +
        this.argent_20dollar * 20 +
        this.argent_50dollar * 50 +
        this.argent_100dollar * 100 +
        this.rouleaux_5cent * 2 +
        this.rouleaux_10cent * 5 +
        this.rouleaux_25cent * 10 +
        this.rouleaux_1dollar * 25 +
        this.rouleaux_2dollar * 50;
      this.$emit("update:total", round10.round10(total, -2));
      this.$emit("update:valid", total > 0);
    },
    getDifference(field) {
      return this[field] - this.current[field];
    }
  }
};
</script>

<style lang="scss" scoped>
.field-chip {
  min-width: 55px;
  display: flex;
  justify-content: flex-end;
}
</style>
